// ParticipantEngagementRiskService.ts

import { PagedResults, ApiResponse } from "../../interfaces/genericResponse/GenericResponse";
import { EngagementRiskDto, EngagementRiskRequest } from "../../interfaces/participant/ParticipantEngagementRisk";

/**
 * Fetches the paginated engagement risk report for participants.
 * @param authToken - The user's bearer token.
 * @param req - Pagination and sorting options.
 */
export async function getEngagementRiskReport(
    authToken: string,
    req: EngagementRiskRequest
): Promise<ApiResponse<PagedResults<EngagementRiskDto>>> {
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/participants/engagement-risk`;

    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(req)
        });

        if (!response.ok) {
            // Attempt to parse error message from API if available
            let errorMessage = "Failed to fetch engagement risk report";
            try {
                const errorBody = await response.json();
                errorMessage = errorBody?.message || errorMessage;
            } catch {
                // Ignore JSON parse errors on failure
            }
            throw new Error(errorMessage);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching engagement risk report:', error);
        throw error;
    }
}